export const CATEGORIES = ['agricultural', 'lumbering', 'civilengineering']
